import { VIEW_FOLLOWERS } from '../constants/ActionTypes'

export default function (state = {}, action) {
	switch (action.type) {
		case VIEW_FOLLOWERS:
			const key = action.user_id
			return {
				...state,
				[key]: action.payload
			}
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/reducers/followers.js